import { useQuery } from '@tanstack/react-query';
import { fetch_booking_list, fetch_booking_detail, fetch_booking_counts } from './api';
import type { BookingListFilters } from './types';
import type { SortState } from '@/hooks/use-url-state';

const KEYS = {
  list: (filters: BookingListFilters, sort?: SortState) =>
    ['admin-booking-list', filters, sort] as const,
  counts: () => ['admin-booking-counts'] as const,
  detail: (id: string) => ['admin-booking-detail', id] as const,
};

export function use_booking_list(filters: BookingListFilters, sort?: SortState) {
  return useQuery({
    queryKey: KEYS.list(filters, sort),
    queryFn: () => fetch_booking_list(filters, sort),
    placeholderData: (prev) => prev,
  });
}

export function use_booking_counts() {
  return useQuery({ queryKey: KEYS.counts(), queryFn: fetch_booking_counts });
}

export function use_booking_detail(id: string | undefined) {
  return useQuery({
    queryKey: id ? KEYS.detail(id) : ['admin-booking-detail', 'noop'],
    queryFn: () => fetch_booking_detail(id as string),
    enabled: typeof id === 'string' && id.length > 0,
  });
}
